import React from "react";
import "../styles/Recipe.css";

const Recipe = ({ recipe, onClose }) => {
  if (!recipe) return null;

  const totalCalories = recipe.ingredients.reduce((sum, ingredient) => 
    sum + (ingredient.calories || 0), 0
  );
  
  const totalProtein = recipe.ingredients.reduce((sum, ingredient) => 
    sum + (ingredient.protein || 0), 0
  );

  return (
    <div className="recipe-overlay" onClick={onClose}>
      <div className="recipe-modal" onClick={(e) => e.stopPropagation()}>
        <div className="recipe-header">
          <h2 className="recipe-title">{recipe.title}</h2>
          <button 
            className="recipe-close-btn" 
            onClick={onClose}
            aria-label="Close recipe"
          >
            ×
          </button>
        </div>
        
        <div className="recipe-content">
          <div className="recipe-nutrition">
            <div className="nutrition-item">
              <span className="nutrition-label">Total Calories:</span>
              <span className="nutrition-value">{totalCalories}</span>
            </div>
            <div className="nutrition-item">
              <span className="nutrition-label">Total Protein:</span>
              <span className="nutrition-value">{totalProtein}g</span>
            </div>
          </div>

          <div className="recipe-ingredients">
            <h3>Ingredients</h3>
            <ul className="ingredients-list">
              {recipe.ingredients.map((ingredient, index) => (
                <li key={index} className="ingredient-item">
                  <div className="ingredient-main">
                    <span className="ingredient-quantity">
                      {ingredient.quantity} {ingredient.unit}
                    </span>
                    <span className="ingredient-name">{ingredient.name}</span>
                  </div>
                  {(ingredient.calories || ingredient.protein) && (
                    <div className="ingredient-nutrition">
                      {ingredient.calories && (
                        <span className="ingredient-calories">
                          {ingredient.calories} cal
                        </span>
                      )}
                      {ingredient.protein && (
                        <span className="ingredient-protein">
                          {ingredient.protein}g protein
                        </span>
                      )}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Recipe;